import { createUseStyles } from "react-jss";

export const AboutIOSContainerStyle = createUseStyles((theme: any) => ({
    container: {},
    sectionTitle: {
        color: "var(--text-color-purple)",
        fontWeight: "bold",
        fontSize: "var(--font-size-lg)",
    },
    listType: {
        listStyleType: "circle",
    },
    listDescription: {
        color: "var(--text-color-purple)",
        fontWeight: "bolder",
    },
    listRow: {
        paddingTop: "var(--padding-sizes-xs)",
        paddingBottom: "var(--padding-sizes-xs)",
    },
    listText: {
        color: "var(--color-default-text)",
        opacity: "1",
        fontWeight: "normal",
    },
    icon: {
        cursor: "pointer",
    },
}));
